import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/views/home'



import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'

Vue.use(Router)


import messages from '@/translations';

let es = messages.es.enlaces;
let en = messages.en.enlaces;
let it = messages.it.enlaces;

export default new Router({
	mode : 'history',
	routes: [
	{path: '/',component: Home},
	{path: es.politica_privacidad,component: politicaPrivacidad},
	{path: es.politica_cookies,component: politicaCookies},
	{ path: '*', redirect: '/404' },
	{ path: "/404", component: Error404 }
	],
	scrollBehavior (to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
})



// WEBPACK FOOTER //
// ./src/router/index.js